var _defs, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesmoj10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.09 10.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2a5b2f;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.48 8.81 2.82 6.2 .88 8.44 .12 7.79 2.66 4.86 6.24 7.42 11.6 -.11 13.18 3.24 12.28 3.67 11.42 1.86 6.48 8.81"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.09 10.52 0 10.52 0 0 1 0 1 9.52 13.09 9.52 13.09 10.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesmoj10);
export default __webpack_public_path__ + "static/media/icones moj-10.555bb50d360e2190600e877c8f02f155.svg";
export { ForwardRef as ReactComponent };